import * as React from "react";
import {
  List,
  DataTable,
  TextField,
  BooleanField,
  EditButton,
  EmailField,
  ReferenceField,
  TextInput,
  BooleanInput,
  AutocompleteInput,
  ReferenceInput,
} from "react-admin";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";

const UserFilter = () => {
  return [
    <TextInput source="email" alwaysOn />,
    <ReferenceInput
      source="restaurant"
      reference="restaurants"
      perPage={100}
      filter={{
        type: RESTAURANT_TYPES.REGULAR,
      }}
      label="Restaurante"
      alwaysOn
    >
      <AutocompleteInput
        filterToQuery={(searchText) => ({ name: searchText })}
        label="Restaurante"
        optionText="name"
      />
    </ReferenceInput>,
    <BooleanInput label="Activo" source="active" />,
    <BooleanInput label="Confirmado" source="confirmed" />,
    <TextInput source="phone" label="Teléfono" />,
  ];
};

const UserList = () => (
  <List title={"Usuarios"} filters={UserFilter()} exporter={false}>
    <DataTable rowClick="show" bulkActionButtons={false}>
      <DataTable.Col source="firstName" label="Nombre" />
      <DataTable.Col source="lastName" label="Apellido" />
      <DataTable.Col source="email" label="Email">
        <EmailField source="email" label="Email" />
      </DataTable.Col>
      <DataTable.Col source="restaurant">
        <ReferenceField
          source="restaurant"
          reference="restaurants"
          link={false}
        >
          <TextField source="name" />
        </ReferenceField>
      </DataTable.Col>
      <DataTable.Col source="phone" label="Teléfono" />
      <DataTable.Col source="active" label="Activo">
        <BooleanField source="active" label="Activo" />
      </DataTable.Col>
      <DataTable.Col source="confirmed" label="Confirmado">
        <BooleanField source="confirmed" label="Confirmado" />
      </DataTable.Col>
      <DataTable.Col>
        <EditButton />
      </DataTable.Col>
    </DataTable>
  </List>
);

export default UserList;
